export const dateFromString = (input) => {
	if (! input) return false;

	// german format like "24.12.2020"
	if (input.match(/^\d{2}\.\d{2}\.\d{4}$/)) {
		const parts = input.split('.');
		return new Date(parts[ 2 ], (parts[ 1 ] - 1), parts[ 0 ]);
	}

	// english format like "23/10/2019"
	if (input.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
		const parts = input.split('/');
		return new Date(parts[ 2 ], (parts[ 1 ] - 1), parts[ 0 ]);
	}

	// american format like "10/23/2019 00:00:00"
	// (opentext sometimes appends midnight time to english dates)
	if (input.match(/^\d{2}\/\d{2}\/\d{4} 00:00:00$/)) {
		const parts = input.split(' ')[ 0 ].split('/');
		return new Date(parts[ 2 ], (parts[ 0 ] - 1), parts[ 1 ]);
	}

	return false;
};

// return format: "24.12.2020"
export const dateToGermanString = (date) => {
	if (! (date instanceof Date)) {
		return '';
	}

	return ((date.getDate() < 10) ? '0' + date.getDate() : date.getDate())
		+ '.' +
		(((date.getMonth() + 1) < 10) ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1))
		+ '.' +
		date.getFullYear();
};

// return format: "24/12/2020"
export const dateToEnglishString = (date) => {
	if (! (date instanceof Date)) {
		return '';
	}

	return ((date.getDate() < 10) ? '0' + date.getDate() : date.getDate())
		+ '/' +
		(((date.getMonth() + 1) < 10) ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1))
		+ '/' +
		date.getFullYear();
};

export const getDatesFromEntry = (entry) => {
	const fromDate = dateFromString(entry.dateFrom);
	const toDate = dateFromString(entry.dateTo);
	if (fromDate && toDate) {
		return [ fromDate, toDate ];
	} else if (fromDate) {
		return [ fromDate, false ];
	}

	// try parsing from headline
	// format: "09.11.2020 - 22.02.2021"
	let matches = entry.headline.match(/(\d{2}\.\d{2}\.\d{4}) ?- ?(\d{2}\.\d{2}\.\d{4})/);
	if (matches) {
		return [ dateFromString(matches[ 1 ]), dateFromString(matches[ 2 ]) ];
	}

	// format: "21.05. - 05.09.2021"
	matches = entry.headline.match(/(\d{2}\.\d{2}\.) ?- ?(\d{2}\.\d{2}\.)(\d{4})/);
	if (matches) {
		const fullFrom = matches[ 1 ] + '.' + matches[ 3 ];
		const fullTo = matches[ 2 ] + matches[ 3 ];
		return [ dateFromString(fullFrom), dateFromString(fullTo) ];
	}

	// format: "14.-15.10.2021" AND "14./15.10.2021"
	matches = entry.headline.match(/(\d{2})\. ?-?\/? ?(\d{2})\.(\d{2}\.\d{4})/);
	if (matches) {
		const fullFrom = matches[ 1 ] + '.' + matches[ 3 ];
		const fullTo = matches[ 2 ] + '.' + matches[ 3 ];
		return [ dateFromString(fullFrom), dateFromString(fullTo) ];
	}

	// format: "09.11.2020" (fromDate only)
	matches = entry.headline.match(/\d{2}\.\d{2}\.\d{4}/);
	if (matches) {
		return [ dateFromString(matches[ 0 ]), false ];
	}

	// format: "09.11.20" (fromDate only)
	matches = entry.headline.match(/(\d{2}\.\d{2}\.)(\d{2})/);
	if (matches) {
		const fullDate = matches[ 1 ] + '20' + matches[ 2 ];
		return [ dateFromString(fullDate), false ];
	}

	// no match possible
	return [ false, false ];
};

export const normalizeDate = (entry, language) => {
	// eslint-disable-next-line prefer-const
	let [ dateFrom, dateTo ] = getDatesFromEntry(entry);

	if (dateFrom && dateTo && dateFrom.getTime() === dateTo.getTime()) {
		dateTo = false;
	}

	switch (language) {
		case "de" :
			entry.dateFrom = dateFrom ? dateToGermanString(dateFrom) : "";
			entry.dateTo = dateTo ? dateToGermanString(dateTo) : "";
			break;
		case "en" : {
			entry.dateFrom = dateFrom ? dateToEnglishString(dateFrom) : "";
			entry.dateTo = dateTo ? dateToEnglishString(dateTo) : "";
		}
	}

	return entry;
};

export const dateFromYearMonth = (year, month = false, yearIncluded = false) => {
	if (! year) {
		return false;
	}
	if (month) {
		return new Date(year, month);
	}

	if (yearIncluded) {
		return new Date(year, 11, 31);
	}

	return new Date(year, 0);
};
